import { Route, Routes } from 'react-router-dom'
import { AdminAuthProvider } from './AuthContext'
import { AdminShell } from './AdminShell'
import LoginPage from './LoginPage'
import HomePage from './pages/HomePage'
import InsightsPage from './pages/InsightsPage'
import InsightViewPage from './pages/InsightViewPage'
import InsightFormPage from './pages/InsightFormPage'
import CaseStudiesPage from './pages/CaseStudiesPage'
import CaseStudyViewPage from './pages/CaseStudyViewPage'
import CaseStudyFormPage from './pages/CaseStudyFormPage'
import TeamPage from './pages/TeamPage'
import TeamFormPage from './pages/TeamFormPage'
import ClientsPage from './pages/ClientsPage'
import ClientFormPage from './pages/ClientFormPage'
import FaqsPage from './pages/FaqsPage'
import PoliciesPage from './pages/PoliciesPage'
import SettingsPage from './pages/SettingsPage'
import SubmissionsPage from './pages/SubmissionsPage'

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route element={<AdminShell />}>
          <Route index element={<HomePage />} />
          <Route path="insights" element={<InsightsPage />} />
          <Route path="insights/new" element={<InsightFormPage />} />
          <Route path="insights/:id/edit" element={<InsightFormPage />} />
          <Route path="insights/:id" element={<InsightViewPage />} />
          <Route path="case-studies" element={<CaseStudiesPage />} />
          <Route path="case-studies/new" element={<CaseStudyFormPage />} />
          <Route path="case-studies/:id/edit" element={<CaseStudyFormPage />} />
          <Route path="case-studies/:id" element={<CaseStudyViewPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="team/new" element={<TeamFormPage />} />
          <Route path="team/:id/edit" element={<TeamFormPage />} />
          <Route path="clients" element={<ClientsPage />} />
          <Route path="clients/new" element={<ClientFormPage />} />
          <Route path="clients/:id/edit" element={<ClientFormPage />} />
          <Route path="faqs" element={<FaqsPage />} />
          <Route path="policies" element={<PoliciesPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="submissions" element={<SubmissionsPage />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  )
}
